
import { ageAt, Gender, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import { MiscService } from 'app/services/MiscService'
import * as utils from 'app/utils'
import * as Config from 'config'
import * as _ from 'lodash'
import * as moment from 'moment'

interface ILifeTableEntry {
  age: number,
  moreYears: number,
  ageAtDeath: number
}

type ILifeExpectancyMap = {
  [g in Gender]?: ILifeTableEntry
}

let masterTable: ILifeExpectancyMap[]

function parseRow(row): ILifeExpectancyMap {
  const m = (ix: number) => ({
    age: row[ix],
    moreYears: row[ix + 1],
    ageAtDeath: row[ix + 2]
  })
  return {
    [Gender.unidentified]: m(0),
    [Gender.male]: m(4),
    [Gender.female]: m(8)
  }
}

class LifeExpectancyService {

  static getLifeExpectancy(member: IRetirementPerson): Promise<number> {
    const age = ageAt(member, utils.todaysDate())
    return LifeExpectancyService.expectancyTable()
      .then((table) => {
        // this isn't going to work if there are holes in the table...
        const exact = _.find(table, (e) => e[member.gender].age === age)
        // tslint:disable-next-line:no-debugger
        //debugger
        if (exact) { return exact[member.gender].ageAtDeath }
        const f = _.first(table)
        return (age < f[member.gender].age) ? f[member.gender].ageAtDeath : _.last(table)[member.gender].ageAtDeath
      })
  }

  static expectancyTable(): Promise<ILifeExpectancyMap[]> {
    if (masterTable) { return Promise.resolve(masterTable) }

    // go grab the life expectancy table from the server
    const endpoint = Config.getWebServicesConfig().miscEndpoint
    const svc = new MiscService(endpoint)
    return svc.getLifeExpectancyTable()
      .then((result) => {
        // mutate the table into something easier to use
        return masterTable = _(result.table as any[])
          .drop(3) // the header rows
          .map(parseRow)
          .orderBy((q: ILifeExpectancyMap) => q[Gender.male].age)
          .value()
      })
  }
}

export {
  ILifeExpectancyMap,
  ILifeTableEntry,
  LifeExpectancyService
}



// WEBPACK FOOTER //
// ./src/app/services/LifeExpectancyService/index.ts